<template>
    <nav class>
        <div class="m_menu_top D_none">
            <div class="utility_wrap D_none">
                <!-- login 전 -->
                <template v-if="!state.isLogin">
                    <a href="" class="icon_wrap center_btn go_center">
                        <img src="img/center.png" alt="다시함께상담센터" />
                    </a>
                    <div class="m_btn_wrap">
                        <router-link to="/login" class="m_btn _blue">로그인</router-link>
                        <router-link to="/join" class="m_btn _gray">회원가입</router-link>
                    </div>
                </template>
                <!-- login 전 -->
                <!-- login 후 -->
                <template v-else>
                    <div class="_flex after_login">
                        <div class="user_btn">
                            <img src="img/user_icon.png" alt="" />
                            <span class="elips_1">{{ user.userInfo.name }}님</span>
                        </div>
                        <a href="" class="icon_wrap center_btn go_center">
                            <img src="img/center.png" alt="다시함께상담센터" />
                        </a>
                    </div>
                    <div class="m_btn_wrap">
                        <router-link to="/mypage" class="m_btn">마이페이지</router-link>
                        <button @click="logout" class="m_btn _gray">로그아웃</button>
                    </div>
                </template>
                <!-- login 후 -->
            </div>
        </div>
        <div class="nav_bg"></div>
        <ul class="depth_01" :class="[state.customClass ? '_white' : '']">
            <li>
                <button class="_intro">소개</button>
                <ul class="depth_02">
                    <li :class="[state.currentPath === '/intro?type=1' ? 'active' : '']">
                        <router-link to="/intro?type=1" @click="global.setIntroTab(1)">반성매매 시민참여 플랫폼</router-link>
                    </li>
                    <li :class="[state.currentPath === '/intro?type=2' ? 'active' : '']">
                        <router-link to="/intro?type=2" @click="global.setIntroTab(2)">다시함께상담센터</router-link>
                    </li>
                    <li :class="[state.currentPath === '/intro?type=3' ? 'active' : '']">
                        <router-link to="/intro?type=3" @click="global.setIntroTab(3)">자주 묻는 질문</router-link>
                    </li>
                </ul>
            </li>
            <li>
                <button class="_report">시민제보창</button>
                <ul class="depth_02">
                    <li :class="[state.currentPath === '/report?type=1' ? 'active' : '']">
                        <router-link
                            to="/report?type=1"
                            @click="
                                global.setReportTab(1);
                                state.currentPath = '/report?type=1';
                            "
                        >
                            성매매 의심 업소 제보
                        </router-link>
                    </li>
                    <li :class="[state.currentPath === '/report?type=2' ? 'active' : '']">
                        <router-link
                            to="/report?type=2"
                            @click="
                                global.setReportTab(2);
                                state.currentPath = '/report?type=2';
                            "
                        >
                            성매매 알선 광고 제보
                        </router-link>
                    </li>
                </ul>
            </li>
            <li>
                <button class="_activity">시민참여 활동</button>
                <ul class="depth_02">
                    <li :class="[state.currentPath === '/board?type=1' ? 'active' : '']">
                        <router-link to="/board?type=1" @click="global.setBoardTab(1)">반성매매 시민활동</router-link>
                    </li>
                    <li :class="[state.currentPath === '/board?type=2' ? 'active' : '']">
                        <router-link to="/board?type=2" @click="global.setBoardTab(2)">캠페인·이벤트</router-link>
                    </li>
                    <li :class="[state.currentPath === '/board?type=3' ? 'active' : '']">
                        <router-link to="/board?type=3" @click="global.setBoardTab(3)">
                            참여하고 싶은
                            <br class="none_1024" />
                            반성매매 활동 제안
                        </router-link>
                    </li>
                    <li v-if="user.isLogin()" :class="[state.currentPath === '/board?type=4' ? 'active' : '']">
                        <router-link to="/board?type=4" @click="global.setBoardTab(4)">액션 시민 활동</router-link>
                    </li>
                </ul>
            </li>
            <li>
                <button class="_news">감시소식</button>
                <ul class="depth_02">
                    <li :class="[state.currentPath === '/news' ? 'active' : '']">
                        <router-link to="/news">감시소식</router-link>
                    </li>
                    <li :class="[state.currentPath === '/archive' ? 'active' : '']">
                        <router-link to="/archive">자료집</router-link>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>

<script lang="ts">
    import {
        computed,
        onMounted,
        apiService,
        globalStore,
        useRoute,
        inject,
        reactive,
        router,
        userStore,
        defineComponent,
        types,
        watch,
    } from "@/BaseComponent";

    export default defineComponent({
        props: {
            customClass: {
                type: Boolean,
                default: false,
            },
        },
        setup(props: any) {
            const route = useRoute();
            const user: any = userStore();
            const global = globalStore();
            const menu = reactive({});

            const state = reactive({
                isLogin: false,
                customClass: [] as Array<string>,
                currentPath: "" as string,
            });

            onMounted(async () => {
                await me();

                state.customClass = props.customClass;
                state.currentPath = route.fullPath;
            });

            watch(
                () => props.customClass,
                () => {
                    state.customClass = props.customClass;
                },
            );

            watch(
                () => route.fullPath,
                () => {
                    state.currentPath = route.fullPath;
                },
            );

            const me = async () => {
                if (user && user.accessToken != null && user.accessToken != "") {
                    let res: types.ResUserInfo = await apiService.mypage.me();

                    if (res !== null && res.returnCode === 0) {
                        state.isLogin = true;
                    } else {
                        state.isLogin = false;
                    }
                }
            };

            const logout = async () => {
                if (user && user.accessToken != null && user.accessToken != "") {
                    let res: types.BaseResponse = await apiService.auth.logout();

                    if (res !== null && res.returnCode === 0) {
                        state.isLogin = false;
                        router.replace("/");
                        user.$reset();
                    } else {
                        state.isLogin = true;
                    }
                }
            };

            return {
                global,
                user,
                menu,
                router,
                state,
                logout,
            };
        },
    });
</script>

<style scoped></style>
